export default function InvestigationDetailPage() {
  return null;
}
